// Legacy jQuery-based application code, loaded via Vite
// (migrated from importmap to fix Firefox module loading conflict)

import '../src/legacy/vendor/toastr/toastr.2.10.0'
import '../src/legacy/vendor/toastr/toastr.config'

import '../src/legacy/vendor/highlight.pack'

import '../src/legacy/vendor/nprogress-0.2.0'
import 'sweetalert'

import '../src/legacy/vendor/js.cookie'

import '../src/legacy/jquery-ujs'

import '../src/legacy/selectize-standalone-0.12.6'

//##############################################################################
// Load app and the rest of the tree
//##############################################################################
import '../src/legacy/app'

import '../src/legacy/vendor/chartkick/chartkick-2.2.4'
import '../src/legacy/vendor/Chart.bundle.min'
import '../src/legacy/google-jsapi/20150205'
import '../src/legacy/vendor/jasny-bootstrap/jasny-bootstrap-7c'
import '../src/legacy/admin_sales'
import '../src/legacy/analytics'
import '../src/legacy/birthday_schedules'
import '../src/legacy/busy'
import '../src/legacy/contact_imports'
import '../src/legacy/contacts'
import '../src/legacy/coupons'
import '../src/legacy/credits'
import '../src/legacy/datemask'
import '../src/legacy/datepickers'
import '../src/legacy/dateranges'
import '../src/legacy/dropdowns'
import '../src/legacy/form_errors'
import '../src/legacy/form_submit'
import '../src/legacy/forms'
import '../src/legacy/giant-links'
import '../src/legacy/graphics'
import '../src/legacy/groupings'
import '../src/legacy/groups'
import '../src/legacy/insights'
import '../src/legacy/invites'
import '../src/legacy/keywords'
import '../src/legacy/linkifying_editor'
import '../src/legacy/loading_bar'

import '../src/legacy/message_modal_charts'
import '../src/legacy/message_modal_counter'
import '../src/legacy/message_modal_replies'
import '../src/legacy/message_modal_support'
import '../src/legacy/message_modal_upgrade'
import '../src/legacy/messages'
import '../src/legacy/mobile'
import '../src/legacy/modals'
import '../src/legacy/pagination'
import '../src/legacy/placeholders'
import '../src/legacy/polyfills'
import '../src/legacy/purchases'
import '../src/legacy/referrals'
import '../src/legacy/replies'
import '../src/legacy/right-panel'
import '../src/legacy/scroll_here'
import '../src/legacy/search'
import '../src/legacy/search_filters'
import '../src/legacy/select-multiple'
import '../src/legacy/select_all'
import '../src/legacy/set-timezone'
import '../src/legacy/settings'
import '../src/legacy/shared'
import '../src/legacy/sign_ups'
import '../src/legacy/social'
import '../src/legacy/stripe_helper'
import '../src/legacy/sweetalert-tweaks'
import '../src/legacy/syntax_highlighting'
import '../src/legacy/system_noticings'
import '../src/legacy/tabs'
import '../src/legacy/textarea-counters'
import '../src/legacy/unhide-links'
import '../src/legacy/utils'
import '../src/legacy/web_subscribes'
import '../src/legacy/wizards'

import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

import '../channels/index'
